import type { ErrorEvent } from "@sentry/react";

// Same list as react-shared's `public/auth/auth-failure.ts`, matched on the
// serialized exception types: Amplify's NoSignedUser / NoValidAuthTokens /
// UserUnAuthenticatedException and react-shared's NoSessionFoundError all mean
// the session expired, not that the code is broken. A bare 401 is deliberately
// absent: catch-401 also rethrows one while the session may be fine.
const SESSION_LOST_ERROR_TYPES = new Set([
  "NoSessionFoundError",
  "NoSignedUser",
  "NoValidAuthTokens",
  "UserUnAuthenticatedException",
]);

// Sentry unrolls the cause chain into `exception.values`, so a query assertion
// wrapping the auth error matches as well as the auth error captured alone.
export function isSessionLostEvent(event: ErrorEvent): boolean {
  return Boolean(
    event.exception?.values?.some(
      (value) =>
        typeof value.type === "string" &&
        SESSION_LOST_ERROR_TYPES.has(value.type),
    ),
  );
}
